export const environment = {
  production: false,
  recaptcha: '6LfPTd8mAAAAAI8JTLzFdG0jOUfWe12EkX67xcAt'
};
